import Vue from "vue"
import Vuex from "vuex"
import {
  GetSysUserByCode
} from '@/api/modules/basicData/notification'
import {
  getAllDhcpServer
} from '@/api/modules/basicData/dhcp'
Vue.use(Vuex)

/*
	缓存数据用
*/
const state = {
  userInfo: {},
  dhcpServers: [],
  dhcpAuthType: 0
}
/*
	获取数据 就是属性的get
*/
const getters = {}
/*
	设置数据 就是属性的set
*/
const mutations = {
  setDhcpAuthType(state, item) {
    state.dhcpAuthType = item;
  },
}
/*
	方法
*/
const actions = {
  loadUser({
    state
  }, code) {
    //获取登录人信息
    GetSysUserByCode(code).then(res => {
      state.userInfo = res;
    });
  },
  loadDhcpServer({
    state
  }) {
    getAllDhcpServer().then(res => {
      state.dhcpServers = res;
    });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
